<template>
  <div
    class="bg-white w-full pt-24 pb-12 px-12 border-b border-truegray-100"
    :style="{ height: 'max-content' }"
  >
    <h2
      class="uppercase text-cw-300 font-nunito font-light text-lg pb-4 tracking-widest"
    >
      {{ overline }}
    </h2>
    <slot name="title">
      <h2 class="text-cw-900 font-montserrat">{{ title }}</h2>
    </slot>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PageHeader',

  props: {
    overline: {
      type: String,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },
  },
})
</script>
